import { baseApi } from "api/BaseApi";

import {
  ProjectPp,
  ProtectionProfilesResponse,
} from "./protectionProfiles.types";

const PP_BASE_QUERY = "/project/protection-profiles";

export const protectionProfilesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    groupedProtectionProfiles: build.query<ProtectionProfilesResponse, void>({
      query: () => `${PP_BASE_QUERY}/get_grouped_pp_pcl/`,
    }),

    // TODO: add transform response to convert to camelCase
    projectPpByPid: build.query<ProjectPp[], string | number>({
      query: (product_id) => ({
        url: `${PP_BASE_QUERY}/get_all_projpp_by_product_id/`,
        params: { product_id },
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useGroupedProtectionProfilesQuery, useProjectPpByPidQuery } =
  protectionProfilesApi;
